import { Box } from "@mui/material";

export function NotFoundPage() {
  return <Box>Page not found</Box>;
}
